<template>
    <div>
    </div>
</template>
 
<script>

    export default {
        data() {
            return {
                orderNo: "",
                checkCount: 0
            };
        },
        computed: {
            info() {
                return this.$root.info;
            }
        },
        components: { },
        created() {
            this.info.loading = true;
            this.orderNo = this.$root.getParameterByName("orderNo");
            this.checkMemberLogin();
        },
        destroyed() {
            this.$root.setGoBackAction();
        },
        methods: {
            checkMemberLogin() {
                console.log("checkMemberLogin");
                var app = this;
                app.checkCount++;
                if (app.info.member != null) {
                    app.checkCount = 1000;
                    app.$router.replace(`/` + app.info.lang + "/confirmation?orderNo=" + encodeURIComponent(app.orderNo));
                }
                else {
                    if (this.checkCount <= 100) {
                        window.setTimeout(function () {
                            app.checkMemberLogin();
                        }, 5000);
                    }
                    else {
                        app.$router.replace(`/` + app.info.lang + "/");
                    }
                }
            }

        },
    };
</script>

